import { styled } from '../../config'

export const TextArea = styled('textarea', {
  border: `1px solid $gray0500`,
  borderRadius: '6px',
  background: 'transparent',
  padding: `10px 12px`,
  fontSize: '$14',
  lineHeight: '$20',
  outline: 'none',
  color: '$gray1000',
  transition: 'all 100ms ease',
  maxWidth: '100%',
  marginBottom: '$4',
  '&:placeholder': {
    color: '$gray0800'
  },
  '&:focus': {
    boxShadow: `0px 0px 0px 4px $gray0300`
  },
  '&:disabled': {
    color: '$gray0800'
  },
  variants: {
    dark: {
      true: {
        '&::placeholder': {
          color: '$whiteA500'
        },
        background: '$whiteA050',
        border: 'none',
        color: '$white',
        '&:disabled': {
          color: '$whiteA300'
        }
      }
    },
    round: {
      true: { borderRadius: '$round' }
    },
    noResize: {
      true: { resize: 'none' }
    }
  }
})
